import { columnDefsV2 } from './column-defs';

export function useColumnDefs() {
  return columnDefsV2;
}
